import { render, staticRenderFns } from "./TemporarilyDisaglePostNlButton.vue?vue&type=template&id=8642f91e&scoped=true&"
import script from "./TemporarilyDisaglePostNlButton.vue?vue&type=script&lang=js&"
export * from "./TemporarilyDisaglePostNlButton.vue?vue&type=script&lang=js&"
import style0 from "./TemporarilyDisaglePostNlButton.vue?vue&type=style&index=0&id=8642f91e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8642f91e",
  null
  
)

export default component.exports